import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {PortalService} from '../../../../vna_portal/model/PortalService';
import {AlertaService} from '../../../../../../shared/services/alerta.service';
import {ServiceAccessComponent} from '../../service-access/service-access.component';
import {ModalService} from 'ngx-dynamic-modal';
import {BeeztelServiceAccessUrlVarsComponent} from '../beeztel-service-access-url-vars/beeztel-service-access-url-vars.component';
import {MessagingService} from '../../../../../../core/service/messaging.service';
import {VnaPbxConfigCreated} from '../../../../vna-campaign/model/VnaPbxConfigCreated';
import {CampService} from '../../../../vna-campaign/model/CampService';
import {VnaPbxConfigRemoved} from '../../../../vna-campaign/model/VnaPbxConfigRemoved';

@Component({
  selector: 'app-beeztel-service-access',
  templateUrl: './beeztel-service-access.component.html',
  styleUrls: ['./beeztel-service-access.component.scss']
})
export class BeeztelServiceAccessComponent extends ServiceAccessComponent implements OnInit {

    constructor(protected portalServiceFactory: PortalServiceFactoryService, protected alertaHandler:AlertaService, protected modalService: ModalService, private messaging: MessagingService) {
        super(portalServiceFactory, alertaHandler);
        this.formSearch.setControl('url_login', new FormControl(''));
    }

    ngOnInit() {
        super.ngOnInit();
        this.formSearch.controls['url_login'].setValue(this.portalService.getUrlLogin());

        this.messaging.message.subscribe(
            (r) => {
                if(r instanceof VnaPbxConfigCreated || r instanceof VnaPbxConfigRemoved){
                    this.formSearch.controls['url'].setValue(r.getUrl());
                }
            }
        )

    }

    parseAndCheckUrlVars(): void {
        let urlData = this.formSearch.value.url.split('?');
        let queryString = urlData[1];
        let vars = queryString.split('&');

        this.modalService.addDynamicComponent(BeeztelServiceAccessUrlVarsComponent, vars);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/beeztel/beeztel-service-access/beeztel-service-access.component.ts